export default __webpack_public_path__ + "static/media/swietna_lokalizacja.ba70980e.jpg";